// biome-ignore-all lint/a11y/useSemanticElements: shared component anatomy.
import { cn } from "@thilke/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const toolbarVariants = cva(
  "flex items-center gap-1 rounded-[5px] border border-border bg-chrome p-1 text-chrome-foreground shadow-md backdrop-blur supports-[backdrop-filter]:bg-chrome/90",
  {
    variants: {
      orientation: {
        horizontal: "flex-row",
        vertical: "flex-col",
      },
    },
    defaultVariants: {
      orientation: "horizontal",
    },
  },
);

function Toolbar({
  className,
  orientation,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof toolbarVariants>) {
  return (
    <div
      data-slot="toolbar"
      role="toolbar"
      className={cn(toolbarVariants({ orientation, className }))}
      {...props}
    />
  );
}

function ToolbarGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="toolbar-group"
      role="group"
      className={cn("flex items-center gap-1", className)}
      {...props}
    />
  );
}

export { Toolbar, ToolbarGroup, toolbarVariants };
